"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BeaconThemeProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _beaconTheme = _interopRequireDefault(require("@braze/beacon-theme"));

var _GlobalStyle = require("../GlobalStyle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BeaconThemeProvider = function BeaconThemeProvider(_ref) {
  var children = _ref.children,
      noWrapper = _ref.noWrapper,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _beaconTheme["default"] : _ref$theme;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, noWrapper ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_GlobalStyle.BeaconGlobalStyle, null), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "bcl-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_GlobalStyle.BeaconGlobalStyle, null), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children)));
};

exports.BeaconThemeProvider = BeaconThemeProvider;